
import Vue from "vue";
import CrmHistory from "@/models/crm/crm-history";
import { CrmHistoryAwsDocument } from "@/models/base/crm-history-aws-document";
import { AWSFileService } from "@/services/aws-file-service";
import { CrmService } from "@/services/crm-service";
import { createConfirmBuilder } from "@/setup/confirm-builder";

export default Vue.extend({
	props: {
		event: {
			required: true,
			type: Object as () => CrmHistory
		},
	},
	methods: {
		preview(doc: CrmHistoryAwsDocument) {
			if (!doc.File) return;
			AWSFileService.previewAwsFile(doc.File);
		},
		async download(doc: CrmHistoryAwsDocument) {
			if (!doc.File) return;
			await AWSFileService.downloadFile(doc.File.Token, doc.File.Name);
		},
		async remove(doc: CrmHistoryAwsDocument) {
			let confirmBuilder = createConfirmBuilder.bind(this)();
			confirmBuilder.setMessage(this.$ct("confirm-delete-document"));
			confirmBuilder.setWarningTitle();
			let confirm = await confirmBuilder.show();
			if (!confirm) return;
			await CrmService.deleteCrmHistoryDocument(this.event.ID, doc);
			let index = this.event.AWSDocuments.indexOf(doc);
			if (index >= 0) this.event.AWSDocuments.splice(index, 1);
			if (this.event.AWSDocuments.length === 0) {
				this.$emit("deleted");
			}
		},
	},
	i18nEx: {
		componentPrefix: "components.crm"
	}
});
